import script from "./CustomInput.vue?vue&type=script&setup=true&lang=js"
export * from "./CustomInput.vue?vue&type=script&setup=true&lang=js"

import "./CustomInput.vue?vue&type=style&index=0&id=fdd18e5c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-fdd18e5c"]])

export default __exports__